﻿$(function () {
    $.validator.setDefaults({
        ignore: null,
    });

    // Initialize edit in cart button
    $(".editInCartButton").on("click", function () {
        var productName = $(this).data("pl-productname");
        var uscpIdentifier = $(this).data("pl-uscpidentifier");
        
        puritanLawn.showTwoButtonModal("Shopping Cart",
            "Are you sure you want to modify <b>" + productName + "</b>?",
            "NO",
            null,
            "YES",
            () => {
                var url = "/Order/EditInShoppingCart?uscpIdentifier=" + uscpIdentifier;

                window.location.href = url;
            });
    });

    // Initialize remove from cart button
    $(".removeFromCartButton").on("click", function () {
        var formData = new FormData();
        var uscpIdentifier = $(this).data("pl-uscpidentifier");
        var productName = $(this).data("pl-productname");

        formData.append("uscpidentifier", uscpIdentifier);

        puritanLawn.showTwoButtonModal("Shopping Cart",
            "Are you sure you want to remove <b>" + productName + "</b> from your shopping cart?",
            "NO",
            null,
            "YES",
            () => {
                puritanLawn.ajaxPostMultiPartFormData(puritanLawn.orderServicesBaseAddress + 'RemoveFromShoppingCart',
                    formData,
                    (result) => {
                        window.location.reload();
                    },
                    (response) => {
                        alert("error");
                    }
                );                
            });
    });
});